import { Pie } from "@ant-design/plots";

const CarCategoryChart = ({ cars }) => {
  const map = {};
  cars.forEach(c => {
    const key = c.car_type || "Unknown";
    map[key] = (map[key] || 0) + 1;
  });

  
  

  const data = Object.keys(map).map(k => ({
    type: k,
    value: map[k],
  }));


  return <Pie data={data} angleField="value" colorField="type" />;
};

export default CarCategoryChart;
